import { render, staticRenderFns } from "./accessCode.vue?vue&type=template&id=4623def8&scoped=true&"
import script from "./accessCode.vue?vue&type=script&lang=js&"
export * from "./accessCode.vue?vue&type=script&lang=js&"
import style0 from "./accessCode.vue?vue&type=style&index=0&id=4623def8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623def8",
  null
  
)

export default component.exports